/*
Alternative to the Week Selector for mobile view
*/

import { addDays, isSameWeek, startOfWeek } from 'date-fns';
import { IconButton } from '../base/IconButton';
import styles from './EventsCalendarMobileWeekSelector.module.scss';

type MobileWeekSelectorProps = {
  isCurrentWeek: boolean;
  currentDate: Date;
  // Server time as the base instead of the client clock (see EventsCalendarDaySelector).
  serverNow: Date;

  prevWeek: () => void;
  nextWeek: () => void;
};

export const MobileWeekSelector: React.FC<MobileWeekSelectorProps> = ({
  isCurrentWeek,
  currentDate,
  serverNow,
  prevWeek,
  nextWeek,
}) => {
  const isNextWeek = isSameWeek(
    startOfWeek(addDays(serverNow, 7), { weekStartsOn: 1 }),
    startOfWeek(currentDate, { weekStartsOn: 1 }),
  );
  const isInTwoWeeks = isSameWeek(
    startOfWeek(addDays(serverNow, 14), { weekStartsOn: 1 }),
    startOfWeek(currentDate, { weekStartsOn: 1 }),
  );
  const isInThreeWeeks = isSameWeek(
    startOfWeek(addDays(serverNow, 21), { weekStartsOn: 1 }),
    startOfWeek(currentDate, { weekStartsOn: 1 }),
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.navButton}>
        <IconButton
          onClick={prevWeek}
          src="/icons/chevron_left.svg"
          alt="Vorherige Woche"
          // TODO:CSS outerClassName?
          innerClassName={styles.navButton}
          outerClassName={isCurrentWeek ? styles.hidden : styles.visible}
        />
      </div>
      <div className={isCurrentWeek ? styles.weekLabelCurrent : styles.weekLabelOther}>
        {isCurrentWeek
          ? 'Diese Woche'
          : isNextWeek
            ? 'Nächste Woche'
            : isInTwoWeeks
              ? 'In zwei Wochen'
              : 'In drei Wochen'}
      </div>

      <div className={styles.navButton}>
        <IconButton
          onClick={nextWeek}
          src="/icons/chevron_right.svg"
          alt="Nächste Woche"
          // TODO:CSS outerClassName?
          innerClassName={styles.navButton}
          outerClassName={isInThreeWeeks ? styles.hidden : styles.visible}
        />
      </div>
    </div>
  );
};
